import LocalizedStrings from 'localized-strings';

import { getMobileAppLang } from 'features/Accounting/pages/Estimation/common/utils';

export const locales = new LocalizedStrings(
  {
    en: {
      error: 'An error occurred. Please try again.',
      no: 'No',
      sidebar: {
        answer:
          'If you opt for the settlement payment system, income tax is paid at the same time as your contributions (monthly or quarterly), with a specific rate applied according to your activity. To benefit from this option, your reference tax income must not exceed €27,428 in 2022 per family quotient share.',
        question: 'What are the advantages of opting for withholding tax?',
        title: 'Learn more…',
      },
      title: 'You benefit from withholding income tax',
      yes: 'Yes',
    },
    fr: {
      error: 'Une erreur est survenue. Veuillez réessayer.',
      no: 'Non',
      sidebar: {
        answer:
          'Avec l’option pour le versement libératoire, l’impôt sur le revenu est payé en même temps que vos cotisations (par mois ou par trimestre) avec application d’un taux spécifique en fonction de votre activité. Pour en bénéficier, votre revenu fiscal de référence ne doit pas excéder 27 428 € en 2022 par part de quotient familial.',
        question:
          'Quel est l’avantage d’opter pour le prélèvement libératoire ?',
        title: 'En savoir plus…',
      },
      title:
        'Vous bénéficiez du versement libératoire de l’impôt sur le revenu',
      yes: 'Oui',
    },
  } as const,
  {
    customLanguageInterface: getMobileAppLang,
  },
);
